import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface IAccountManageState {
  modalType: string
  pendingNextStep: string
}

const initialState: IAccountManageState = {
  modalType: '',
  pendingNextStep: '',
}

const accountManageSlice = createSlice({
  name: 'accountManage',
  initialState,
  reducers: {
    updateModalAccountManage: (state, action: PayloadAction<string>) => {
      state.modalType = action.payload
    },
    setPendingNextStep: (state, action: PayloadAction<string>) => {
      state.pendingNextStep = action.payload
    },
    clearPendingNextStep: (state) => {
      state.pendingNextStep = ''
    },
  },
  extraReducers: () => {},
})

export const accountManageActions = accountManageSlice.actions

export default accountManageSlice
